import type { ReactNode } from 'react'
import { DragOverlay as DNDDragOverlay, defaultDropAnimationSideEffects } from '@dnd-kit/core'
import type { DropAnimation } from '@dnd-kit/core'

const dropAnimationConfig: DropAnimation = {
  sideEffects: defaultDropAnimationSideEffects({
    styles: {
      active: {
        opacity: '0.4',
      },
    },
  }),
}

interface Props {
  children?: ReactNode | undefined
}

export const DragOverlay = (props: Props): JSX.Element => {
  const { children } = props

  return (
    <DNDDragOverlay style={{ cursor: 'grabbing' }} dropAnimation={dropAnimationConfig}>
      <div style={{ pointerEvents: 'none' }}>{children}</div>
    </DNDDragOverlay>
  )
}
